export default {
  "home.heading.default": "entra na call",
  "home.heading.loading": "abrindo a sala...",
  "home.heading.join": "pronto pra entrar?",
  "home.heading.joined": "tá dentro",
  "home.heading.pending": "esperando o host",
  "home.body.default": "cria uma sala, manda o link, curte a vibe.",
  "home.body.loading": "peraí, puxando a sala.",
  "home.body.join": "checa a câmera e o mic, e entra.",
  "home.body.joined": "sala on. compartilha o link ou só vai.",
  "home.body.joined_in_room": "na sala — entra aí ou compartilha o link.",
  "home.body.pending": "a sala tá trancada. o host vai te deixar entrar.",
  "home.cta.create": "Criar sala",
  "home.cta.join": "Entrar na sala",
  "home.cta.enter": "Entrar",
  "home.cta.creating": "Criando...",
  "home.cta.joining": "Entrando...",
  "home.cta.opening": "Abrindo...",
  "home.cta.pending": "Esperando aprovação...",
  "home.copy_link": "copiar link",
  "home.copied": "copiado!",
  "home.leave": "sair da sala",
  "home.back": "voltar",
  "home.no_participants": "ninguém aqui ainda",
  "home.join_by_code": "entrar com código",
  "home.code_placeholder": "digite o código",
  "home.name_placeholder": "seu nome",
  "home.people_one": "pessoa",
  "home.people_other": "pessoas",
  "home.marketing.invite.title": "Cria uma sala,\ncompartilha o link.",
  "home.marketing.invite.body": "Um toque pra começar. Manda o link pros amigos e qualquer um entra — sem download, sem cadastro.",
  "home.marketing.invite.preview_url": "yano.ai/SALA",
  "home.marketing.look.title": "Apareça como\nquiser.",
  "home.marketing.look.body": "Filtros, suavização, vinheta — ou borra seu rosto todo. Sua câmera, seu estilo.",
  "home.marketing.host.title": "Seu espaço,\nsuas regras.",
  "home.marketing.host.body": "Tranca a sala, muta alguém ou remove de vez. O host é quem manda.",
  "home.marketing.host.locked": "Sala trancada",
  "home.marketing.host.waiting_to_join": "Esperando pra entrar",
  "home.marketing.host.wants_to_join": "quer entrar",
  "home.marketing.anything.title": "Pra qualquer coisa, real.",
  "home.marketing.anything.body": "Estudar, jogar, daily do trampo, assistir algo junto — ou só jogar conversa fora.",
  "home.marketing.use_case.study_group": "📚 grupo de estudos",
  "home.marketing.use_case.game_night": "🎮 noite de jogos",
  "home.marketing.use_case.standup": "💼 daily",
  "home.marketing.use_case.watch_party": "🍿 watch party",
  "home.marketing.use_case.catch_up": "☕ botar o papo em dia",
  "home.marketing.use_case.jam_session": "🎸 jam session",
  "home.marketing.use_case.book_club": "📖 clube do livro",
  "home.marketing.use_case.coworking": "💻 co-working",
  "ended.heading": "a call acabou",
  "ended.left": "você saiu da sala.",
  "ended.room_ended": "{title} acabou pra você.",
  "ended.rejoin": "entrar de novo",
  "ended.rejoining": "entrando de novo...",
  "ended.home": "voltar pro início",
  "call.connecting": "conectando",
  "call.waiting": "esperando a galera",
  "call.invite_code": "código de convite",
  "call.audio_on": "áudio on",
  "call.muted": "mutado",
  "call.listening": "Ouvindo",
  "call.audio_muted": "Áudio mutado",
  "call.speaking": "falando",
  "call.you": "você",
  "call.you_label": "Você",
  "call.you_suffix": "(você)",
  "call.chat_placeholder": "manda uma mensagem...",
  "call.guest": "convidado",
  "call.room_fallback": "sala",
  "call.focus_view": "Visão em foco",
  "call.grid_view": "Visão em grade",
  "call.swap_main_video": "Trocar vídeo principal",
  "call.open_chat": "Abrir chat",
  "call.close_chat": "Fechar chat",
  "call.leave_room": "Sair da sala",
  "call.confirm_leave": "Sair?",
  "call.mic_on": "Mic on",
  "call.muted_label": "Mutado",
  "call.camera_off": "Câmera off",
  "call.connect_failed": "Falha na conexão — checa a internet e tenta de novo.",
  "call.camera_access_failed": "Não deu pra acessar a câmera. Checa as permissões do navegador e tenta de novo.",
  "call.recording_failed": "A gravação não começou. A call vai rolar sem ela.",
  "call.initialize_failed": "Deu ruim ao iniciar a call. Atualiza a página e tenta de novo.",
  "call.participants": "Participantes",
  "call.open_participants": "Ver participantes",
  "call.close_participants": "Fechar participantes",
  "call.lock_room": "Trancar sala",
  "call.unlock_room": "Destrancar sala",
  "call.locked": "trancada",
  "call.unlocked": "aberta",
  "call.kick_member": "Remover da sala",
  "call.mute_member": "Mutar",
  "call.unmute_member": "Desmutar",
  "call.muted_by_host": "Mutado pelo host",
  "call.waiting_to_join": "Esperando pra entrar",
  "call.approve": "Aprovar",
  "call.deny": "Negar",
  "call.profile_actions": "Ações do perfil",
  "call.profile_in_room": "Na sala",
  "call.profile_role_host": "Host",
  "call.profile_role_you": "Você",
  "call.profile_action_mute": "Mutar áudio",
  "call.profile_action_mute_meta": "Só pra você — a pessoa não vai saber",
  "call.profile_action_dm": "DM 1:1",
  "call.profile_action_dm_meta": "Começar um papo privado",
  "call.profile_action_view": "Ver perfil completo",
  "call.profile_action_view_meta": "Bio, idiomas, sessões passadas",
  "call.profile_action_report": "Denunciar",
  "call.profile_action_report_meta": "Sinalizar pra moderação",
  "call.profile_sheet_close": "Fechar ações do perfil",
  "call.profile_open_actions": "Abrir ações do perfil",
  "call.dm_title": "Mensagem direta",
  "call.dm_back": "Voltar pras ações",
  "call.dm_close": "Fechar DM",
  "call.dm_status_online": "Online",
  "call.dm_in_room_with": "Nesta sala",
  "call.dm_private_label": "Chat privado",
  "call.dm_private_meta": "Só vocês dois veem essas mensagens",
  "call.dm_input_placeholder": "Manda uma DM…",
  "call.dm_send": "Enviar",
  "call.dm_just_now": "agora",
  "call.dm_seen_just_now": "Visto agora",
  "call.dm_typing": "{name} tá digitando…",
  "call.dm_minimize": "Minimizar",
  "call.dm_active_indicator": "Abrir conversa",
  "call.dm_unread_messages": "{count} não lidas",
  "call.dm_toast_tap_to_open": "Toca pra abrir",
  "call.dm_reopen_aria": "Reabrir conversa com {name}",
  "home.join_denied": "O host não deixou você entrar.",
  "home.error.room_not_found": "Esse código de sala não existe.",
  "home.error.profile_required": "Monta seu perfil pra continuar.",
  "home.cta.set_up_profile": "Montar perfil",
  "home.profile_trigger_new": "Toca pra adicionar seus dados",
  "home.profile_trigger_new_aria": "Montar perfil",
  "home.profile_trigger_edit_aria": "Editar perfil",
  "profile.eyebrow_new": "dá um oi",
  "profile.eyebrow_edit": "seu perfil",
  "profile.title_new": "Deixa com a sua cara.",
  "profile.title_edit": "Editar perfil",
  "profile.subtitle": "Alguns detalhes rápidos pra galera saber com quem tá falando.",
  "profile.add_photo": "Adicionar foto",
  "profile.add_photo_soon": "fotos em breve",
  "profile.photo_empty": "toca pra adicionar uma foto",
  "profile.photo_ready": "foto pronta",
  "profile.photo_save_first": "salva o perfil antes de subir uma foto",
  "profile.photo_crop_caption": "enquadra sua foto",
  "profile.photo_auto_caption": "arrasta e dá zoom, a gente salva automático",
  "profile.photo_upload": "Subir foto",
  "profile.photo_replace": "Trocar foto",
  "profile.photo_remove": "Remover foto",
  "profile.photo_cancel": "Cancelar",
  "profile.photo_save": "Salvar foto",
  "profile.photo_uploading": "Subindo foto…",
  "profile.photo_removing": "Removendo foto…",
  "profile.photo_choose_another": "Escolher outra",
  "profile.photo_drag_hint": "Arrasta a foto pro círculo. As mudanças salvam automático.",
  "profile.photo_zoom": "Zoom",
  "profile.photo_horizontal": "Corte horizontal",
  "profile.photo_vertical": "Corte vertical",
  "profile.name_label": "Nome",
  "profile.name_placeholder": "Como a gente te chama?",
  "profile.gender_label": "Eu sou",
  "profile.gender.woman": "Mulher",
  "profile.gender.man": "Homem",
  "profile.gender.unspecified": "Prefiro não dizer",
  "profile.bio_label": "Bio",
  "profile.bio_optional": "opcional",
  "profile.bio_placeholder": "Idiomas que você fala, o que você curte, qualquer coisa…",
  "profile.cta_new": "Bora",
  "profile.cta_edit": "Salvar",
  "profile.saving": "Salvando…",
  "profile.close": "Fechar",
  "profile.error.save_failed": "Não deu pra salvar o perfil. Tenta de novo.",
  "profile.error.avatar_invalid_type": "Escolhe uma imagem PNG, JPEG, GIF ou WebP.",
  "profile.error.avatar_too_large": "Escolhe uma imagem com menos de 5 MB.",
  "profile.error.avatar_too_small": "A imagem precisa ter pelo menos 96x96 pixels.",
  "profile.error.avatar_load_failed": "Não conseguimos ler essa imagem. Tenta outro arquivo.",
  "profile.error.avatar_failed": "Deu ruim ao subir a foto. Tenta de novo.",
  "profile.error.avatar_remove_failed": "Deu ruim ao remover a foto. Tenta de novo.",
  "effects.title": "Efeitos",
  "effects.soft": "Foco suave",
  "effects.vignette": "Vinheta",
  "effects.face": "Borrar rosto",
  "effects.face_preview_only": "Borrar rosto (só preview)",
  "effects.face_viewer_side": "Borrar rosto (pra quem vê)",
  "effects.face_strength": "Intensidade do borrão",
  "effects.grade.off": "OFF",
  "effects.grade.pop": "POP",
  "effects.grade.warm": "QUENTE",
  "effects.grade.cool": "FRIO",
  "effects.grade.bw": "P&B",
  "camera.off": "câmera off",
  "camera.check": "checa sua câmera",
  "camera.retry": "tentar câmera de novo",
  "camera.ready": "câmera pronta",
  "camera.idle.title": "Liga a câmera",
  "camera.idle.hint": "Vamos pedir acesso ao navegador quando você quiser.",
  "camera.idle.button": "Ligar câmera",
  "camera.status.idle": "Esperando você",
  "camera.status.off": "Câmera off",
  "camera.status.loading": "Pedindo acesso à câmera...",
  "camera.status.denied": "Libera a câmera no navegador e tenta de novo.",
  "camera.status.error": "Deu ruim no preview da câmera. Tenta de novo.",
  "camera.status.unsupported": "Esse navegador não suporta acesso à câmera.",
  "camera.status.insecure": "A câmera precisa de HTTPS ou localhost.",
  "camera.status.attach_failed": "O preview da câmera não iniciou. Tenta de novo.",
  "camera.guest_name_placeholder": "Nome do convidado",
  "camera.flip": "Virar câmera",
  "camera.save_name": "Salvar",
  "camera.edit_name": "Editar nome",
  "mic.on": "Desligar mic",
  "mic.off": "Ligar mic",
  "video.on": "Desligar câmera",
  "video.off": "Ligar câmera",
  "chat.title": "chat",
  "chat.close": "Fechar chat",
  "chat.loading": "carregando...",
  "chat.load_earlier": "carregar anteriores",
  "chat.empty": "nenhuma mensagem ainda",
  "chat.send_error": "A mensagem não foi — tenta de novo.",
  "chat.input_placeholder": "manda uma mensagem...",
  "room.host": "Host",
  "app.room_default_title": "Criar uma sala",
  "app.chat_connection_rejected": "O chat não conectou — tenta atualizar a página.",
  "app.copy_failed": "Não deu pra copiar o link. Tenta selecionar e copiar na mão.",
  "app.chat_not_connected": "O chat ainda não conectou. Espera um pouco e tenta de novo.",
  "footer.terms": "Termos e Condições",
  "footer.copyright": "© 2026 Yano.AI"
}
